import { connect } from 'react-redux';
import ServicePrApprovalsList from './servicePrApprovalsList';
import { bindActionCreators } from 'redux';
//import { fetchGoLiveSites} from "services/redux/maintenance/goLiveSite/action";
import {
    getPrListing, acceptApproval, rejectApproval, 
} from 'services/redux/installation/siteListing/action';

const mapStateToProps = (state) => ({
    prListData: state.siteListingReducer.prListData,
  liveFilterDropDown: state.liveSiteDataReducer.liveFilterDropDown
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getPrListing,
      acceptApproval,
      rejectApproval,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ServicePrApprovalsList);
